import {
	Instance,
	SnapshotIn,
	applySnapshot,
	flow,
	getParent,
	getSnapshot,
	types,
} from 'mobx-state-tree';

import { deleteNewsItem, getNewsItem, updateNewsItem } from '@common/api/news';
import Service from '@common/models/Services/Service';
import User from '@common/models/Users/User';
import { storeReference } from '@common/models/helpers';

import Group from '../Groups/Group';
import Location from '../Locations/Location';
import Media from '../Media';
import { INewsModel } from './News';

const NewsItem = types
	.model('NewsItem', {
		id: types.identifierNumber,
		title: types.optional(types.string, ''),
		description: types.maybeNull(types.string),
		service: types.maybeNull(storeReference(Service)),
		locations_ids: types.optional(types.array(Location), []),
		groups_ids: types.optional(types.array(Group), []),
		image_url: types.maybeNull(types.string),
		image: types.maybeNull(Media),
		draft: types.optional(types.boolean, false),
		is_modal: types.maybeNull(types.optional(types.boolean, false)),
		created_at: types.optional(types.string, ''),
		reactions: types.optional(types.map(types.number), {}),
		created_by: types.maybeNull(User),
		published_at: types.maybeNull(types.optional(types.string, '')),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getNewsItem(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteNewsItem(self.id);
				const parent = getParent<INewsModel>(self, 2);
				parent.removeItem(self as INewsItemModel);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any, isGetSnapshot: boolean = true) {
			self.loading = true;
			try {
				const result = yield updateNewsItem(
					self.id,
					isGetSnapshot
						? {
								...getSnapshot(self),
								...data,
							}
						: data,
				);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default NewsItem;

export interface INewsItemModel extends Instance<typeof NewsItem> {}
export type INewsItemSnapshotIn = SnapshotIn<typeof NewsItem>;
